export class ApiError extends Error {
  constructor(message, status, details = null) {
    super(message);
    this.status = status;
    this.details = details;
    this.name = 'ApiError';
  }
}

export async function handleApiResponse(response) {
  if (!response.ok) {
    let errorData = {};
    try {
      errorData = await response.json();
    } catch {
      // Response body isn't JSON (e.g., nginx HTML error page)
    }

    console.error('API Error Response:', {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
      errorData: JSON.stringify(errorData, null, 2)
    });

    // Handle validation errors (422)
    if (response.status === 422) {
      const formattedDetails = Array.isArray(errorData.detail)
        ? errorData.detail
        : [errorData.detail];

      console.error('Validation Error Details:',
        JSON.stringify(formattedDetails, null, 2)
      );

      throw new ApiError(
        'Validation failed',
        response.status,
        formattedDetails
      );
    }

    // Handle other errors
    const message = errorData.detail || response.statusText || 'An unknown error occurred';
    throw new ApiError(message, response.status);
  }

  return response;
}